// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationsPopup_wrapper__lDqe3","popup":"OrganizationsPopup_popup__lTe3w","button":"OrganizationsPopup_button__vSg--"};